module.exports = __webpack_public_path__ + "img/stock4.29d62793.png";